import Axios from 'axios';

const SET_CLIENTE = '/Dfp/SetClients/';
const GET_CLIENTES = '/Dfp/GetClientes/0';

const CLIENTES = '/Dfp/GetClientes/0';

const CAMPANAS = '/Dfp/GetCampanas/';
const LEADS = '/Dfp/GetLeads';

const SET_FORM = '/Dfp/SetForm/';
const FORMS = '/Dfp/GetForms/';
const FIELDS = '/Dfp/GetFieldsTypes/';

const SET_FIELD = '/Dfp/SetField/';
const REMOVE_FIELD = '/Dfp/RemoveField/';

const REMOVE_LIST = '/Dfp/RemoveList/';

const SET_LIST = '/Dfp/SetList/';

const SET_CAMPAIGN = '/Dfp/SetCampaign/';

export default {
  clients: {
    getAll() {
      return Axios.get(GET_CLIENTES);
    },
    set(data){
      return Axios.post(SET_CLIENTE, data);
    }
  },
  filtros: {
    getClientes() {
      return Axios.get(CLIENTES);
    },
    getCampana(id) {
      return Axios.get(CAMPANAS + id);
    }
  },
  Leads:{
    getAll(data){
      return Axios.post(LEADS, data);
    }
  },
  forms: {
    setEncabezado(data){
      return Axios.post(SET_FORM, data)
    },
    getAll(id = 0){
      return Axios.get(`${FORMS}/${id}`)
    },
    getFieldsTypes(id = 0){
      return Axios.get(`${FIELDS}/${id}`)
    },
    setField(data){
      return Axios.post(SET_FIELD, data)
    },
    removeField(data){
      return Axios.delete(REMOVE_FIELD, {data:data})
    },
    RemoveList(data){
      return Axios.delete(REMOVE_LIST, {data:data})
    },
    setList(data){
      return Axios.post(SET_LIST, data)
    }
  },
  campaigns: {
    set(data){
      return Axios.post(SET_CAMPAIGN, data);
    }
  }
};